import { api } from "./client";
import type { CouponRecord } from "./engagement";
import type { MinerProduct } from "./models";

export interface CatalogMiner {
  id: number;
  name: string;
  img?: string;
  img_full?: string;
  time: number;
  income_day: number | string;
  income_all: number | string;
  computing_power: number | string;
  money: number | string;
  discount?: number | string;
  max_mall?: number;
  limited_buy?: number;
  finish_times?: number | string;
  status?: number;
  is_hot?: number;
  is_sold_out?: number;
  type?: number;
}

export interface UserMiner {
  id: number;
  name: string;
  img?: string;
  img_full?: string;
  prize?: number | string;
  today_income?: number | string;
  total_income?: number | string;
  workDay?: number;
  day?: number;
  hour?: number;
  minute?: number;
  second?: number;
  computing_power?: number | string;
  create_time_r?: string;
  expiration_time?: string;
  status?: number;
  start_status?: number;
  type?: number;
}

export function resolveMediaUrl(value?: string) {
  if (!value) return "";
  if (/^(https?:|data:|blob:)/i.test(value)) return value;
  if (value.startsWith("//")) return `https:${value}`;
  return new URL(value, window.location.origin).toString();
}

export function catalogMinerToProduct(
  item: CatalogMiner,
  type: 1 | 2,
): MinerProduct {
  const discounted = Number(item.discount);
  return {
    id: Number(item.id),
    name: item.name,
    price: discounted > 0 ? discounted : Number(item.money),
    dailyIncome: Number(item.income_day),
    totalIncome: Number(item.income_all),
    days: Number(item.time),
    power: Number(item.computing_power),
    image: resolveMediaUrl(item.img_full || item.img),
    badge:
      item.is_hot === 2
        ? "Popular"
        : type === 1
          ? "Computación en la nube"
          : "Minería",
    category: type === 1 ? "cloud" : "miner",
    finishAt:
      Number(item.limited_buy) === 2 && Number(item.finish_times) > 0
        ? Number(item.finish_times)
        : undefined,
  };
}

export const marketplaceApi = {
  catalog: async (type: 1 | 2) =>
    (
      await api.post<{ list: CatalogMiner[] }>("/api/v2/miner/list", {
        type,
        page: 1,
        num: 100,
      })
    ).list,
  activeCounts: () =>
    api.post<{ one: number; two: number; three: number }>(
      "/api/v2/active/count",
    ),
  coupons: async () =>
    (
      await api.post<{ list: CouponRecord[] }>("/api/v2/coupon/list", {
        type: 1,
        page: 0,
        num: 100,
      })
    ).list,
  buy: (minerId: number, num: number, couponId?: string | number) =>
    api.post("/api/v2/buy/miner", { minerId, num, couponId }),
  userMiners: (state: 1 | 2) =>
    api.post<UserMiner[]>("/api/v2/user/miner", { state, page: 1, num: 100 }),
  start: (minerId: number) => api.post("/api/v2/miner/start", { minerId }),
  sell: (minerId: number) => api.post("/api/v2/miner/sell", { minerId }),
};
